module.exports = __webpack_public_path__ + "img/exam4.26c64472.png";